import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({ standalone: true, selector: '[ndpInputEndItem]' })
export class InputEndItemDirective {
  constructor(private host: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.host.nativeElement, 'input-end-item');
  }
}
